import { render } from "./PlaceImporter.vue?vue&type=template&id=00a86620&scoped=true"
import script from "./PlaceImporter.vue?vue&type=script&lang=ts"
export * from "./PlaceImporter.vue?vue&type=script&lang=ts"

import "./PlaceImporter.vue?vue&type=style&index=0&id=00a86620&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-00a86620"

export default script